export const toDateTimeISO = (dateStr: string, timeStr: string) => {
  const date = new Date(dateStr);
  const time = new Date(timeStr);
  date.setHours(time.getHours());
  date.setMinutes(time.getMinutes());
  date.setSeconds(0);
  return date.toISOString();
};
